
namespace TabAurous.HR {

    @Serenity.Decorators.registerClass()
    export class AttendanceGrid extends Serenity.EntityGrid<AttendanceRow, any> {
        protected getColumnsKey() { return 'HR.Attendance'; }
        protected getDialogType() { return AttendanceDialog; }
        protected getIdProperty() { return AttendanceRow.idProperty; }
        protected getInsertPermission() { return AttendanceRow.insertPermission; }
        protected getLocalTextPrefix() { return AttendanceRow.localTextPrefix; }
        protected getService() { return AttendanceService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected addButtonClick() {

            let now = new Date();
            var voucherNo = FormatHelper.GetVoucherNo(98);
            var userDefinition = Q.Authorization.userDefinition; 
            this.editItem(<AttendanceRow>{
                VoucherNo: voucherNo, 
                CompanyId: userDefinition.CompanyId, 
                UserId: userDefinition.UserId, 
                VoucherTypeId: 98,
                TransDate: now.toDateString(), 
            });
        }
    }
}